var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvertenciaIconAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.29,
    height: 32.29,
    viewBox: "0 0 32.29 32.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28026",
    "data-name": "Grupo 28026",
    transform: "translate(-1312.186 -216.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attention",
    transform: "translate(1309.389 213.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.948,10.2H1.033L.012,2.915A2.659,2.659,0,0,1,2.49,0h0A2.431,2.431,0,0,1,4.968,2.915Z",
    transform: "translate(16.453 10.203)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M3.644,4.373H2.186A2.242,2.242,0,0,1,0,2.186H0A2.242,2.242,0,0,1,2.186,0H3.644A2.242,2.242,0,0,1,5.83,2.186h0A2.242,2.242,0,0,1,3.644,4.373Z",
    transform: "translate(16.028 24.778)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28029",
    "data-name": "Grupo 28029",
    transform: "translate(1108.158 382.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108687",
    "data-name": "Trazado 108687",
    d: "M220.173-166.271a16.145,16.145,0,0,0-16.145,16.145,16.145,16.145,0,0,0,16.145,16.145,16.145,16.145,0,0,0,16.145-16.145A16.145,16.145,0,0,0,220.173-166.271Zm0,30.315A14.17,14.17,0,0,1,206-150.126a14.17,14.17,0,0,1,14.17-14.17,14.17,14.17,0,0,1,14.17,14.17A14.17,14.17,0,0,1,220.173-135.956Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertenciaIconAlert);
export default __webpack_public_path__ + "static/media/AdvertenciaIconAlert..83ef4d2ebed0fd72bb7c4ddc1bdce79a.svg";
export { ForwardRef as ReactComponent };